// removed by extract-text-webpack-plugin
module.exports = {"quantitySelect":"Buttons__quantitySelect__aba892ce"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Sidebar/styles/Buttons.scss
// module id = 3418
// module chunks = 7